
export const navigation = [
  { name: 'Главная', href: '/' },
  { name: 'Услуги', href: '/services' },
  { name: 'Портфолио', href: '/portfolio' },
  { name: 'О нас', href: '/about' },
  { name: 'Контакты', href: '/contact' }
];

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' }
];

export const services = [
  {
    id: 1,
    title: 'Ремонтные работы',
    description: 'Полный ремонт квартир, домов и коммерческих помещений с использованием качественных материалов',
    icon: 'ri-hammer-line',
    image: 'https://public.readdy.ai/ai/img_res/385df635a01f4e3bf9154ccef402b061.jpg'
  },
  {
    id: 2,
    title: 'Малярные работы',
    description: 'Внутренняя и наружная покраска стен, потолков, фасадов с профессиональным подходом',
    icon: 'ri-brush-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20painters%20working%20on%20interior%20walls%20in%20Swiss%20home%2C%20clean%20white%20walls%20being%20painted%2C%20modern%20tools%20and%20equipment%2C%20minimalist%20clean%20workspace%2C%20natural%20lighting&width=400&height=300&seq=painting1&orientation=landscape'
  },
  {
    id: 3,
    title: 'Штукатурные работы',
    description: 'Выравнивание стен, декоративная штукатурка, восстановление поверхностей',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20plastering%20work%20on%20walls%20in%20Swiss%20building%2C%20smooth%20wall%20surfaces%20being%20prepared%2C%20construction%20tools%20and%20materials%2C%20clean%20work%20environment%2C%20quality%20craftsmanship&width=400&height=300&seq=plastering1&orientation=landscape'
  },
  {
    id: 4,
    title: 'Напольные покрытия',
    description: 'Укладка паркета, ламината, плитки, линолеума с подготовкой основания',
    icon: 'ri-layout-grid-line',
    image: 'https://static.readdy.ai/image/42d13efc32449c379a28fcec32248951/54f23b008e6beda815f7bd14f3356bfe.jpeg'
  },
  {
    id: 5,
    title: 'Фасадные работы',
    description: 'Утепление фасадов, облицовка, ремонт и покраска наружных стен',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20facade%20work%20on%20Swiss%20building%20exterior%2C%20workers%20on%20scaffolding%20renovating%20building%20facade%2C%20clean%20modern%20architecture%2C%20quality%20construction%20materials%2C%20Alpine%20background&width=400&height=300&seq=facade1&orientation=landscape'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Сара Джонсон',
    location: 'Женева',
    rating: 5,
    text: 'Выдающиеся ремонтные работы в нашей квартире. Команда была профессиональной, пунктуальной и обеспечила исключительное качество. Настоятельно рекомендую Alpbuild.',
    project: 'Ремонт квартиры'
  },
  {
    id: 2,
    name: 'Михаэль Вебер',
    location: 'Лозанна',
    rating: 5,
    text: 'Отличные фасадные работы и утепление. Проект был завершен вовремя и в рамках бюджета. Очень доволен профессиональным подходом.',
    project: 'Утепление фасада'
  },
  {
    id: 3,
    name: 'Елена Росси',
    location: 'Монтрё',
    rating: 5,
    text: 'Идеальные малярные и отделочные работы в нашем новом доме. Чистая, точная работа с высококачественными материалами.',
    project: 'Внутренняя покраска'
  },
  {
    id: 4,
    name: 'Давид Мартинес',
    location: 'Во',
    rating: 5,
    text: 'Полная реновация офиса была выполнена профессионально от начала до конца. Отличная коммуникация и превосходные результаты.',
    project: 'Реновация офиса'
  }
];

export const portfolio = [
  // Interior Finishing Works
  {
    id: 1,
    title: 'Штукатурные работы в квартире',
    category: 'Внутренняя отделка',
    location: 'Женева',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20plastering%20work%20in%20Swiss%20apartment%2C%20smooth%20white%20walls%20being%20finished%2C%20high%20quality%20craftsmanship%2C%20clean%20modern%20interior%20space%2C%20natural%20lighting%20showing%20perfect%20wall%20texture%20and%20finish&width=600&height=400&seq=portfolio-plaster1&orientation=landscape',
    description: 'Выравнивание стен и декоративная штукатурка в 4-комнатной квартире'
  },
  {
    id: 2,
    title: 'Деревянные работы в доме',
    category: 'Внутренняя отделка',
    location: 'Во',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20custom%20woodwork%20installation%20in%20Swiss%20home%20interior%2C%20elegant%20wooden%20panels%20and%20trim%2C%20quality%20carpentry%20craftsmanship%2C%20warm%20natural%20wood%20tones%2C%20modern%20minimalist%20design%20with%20professional%20finish&width=600&height=400&seq=portfolio-wood1&orientation=landscape',
    description: 'Установка деревянных панелей и столярные работы'
  },
  {
    id: 3,
    title: 'Полная отделка офиса',
    category: 'Внутренняя отделка',
    location: 'Лозанна',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20interior%20finishing%20in%20Lausanne%20Switzerland%2C%20professional%20construction%20work%20with%20clean%20walls%20and%20quality%20materials%2C%20contemporary%20business%20space%20design%2C%20bright%20natural%20lighting%2C%20Swiss%20quality%20standards&width=600&height=400&seq=portfolio-office1&orientation=landscape',
    description: 'Полная внутренняя отделка коммерческого помещения'
  },

  // Painting and Coatings
  {
    id: 4,
    title: 'Покраска стен и потолков',
    category: 'Покраска и покрытия',
    location: 'Женева',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20painting%20work%20in%20Geneva%20apartment%2C%20painters%20applying%20smooth%20white%20paint%20on%20walls%20and%20ceilings%2C%20clean%20workspace%20with%20quality%20tools%2C%20perfect%20finish%20and%20attention%20to%20detail%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-paint1&orientation=landscape',
    description: 'Профессиональная покраска жилого помещения'
  },
  {
    id: 5,
    title: 'Декоративные покрытия',
    category: 'Покраска и покрытия',
    location: 'Монтрё',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20decorative%20wall%20coating%20in%20Swiss%20luxury%20home%2C%20textured%20decorative%20finish%20with%20sophisticated%20design%2C%20high-end%20interior%20materials%2C%20professional%20application%20technique%2C%20warm%20ambient%20lighting%20showcasing%20texture&width=600&height=400&seq=portfolio-decorative1&orientation=landscape',
    description: 'Нанесение декоративных покрытий в частном доме'
  },
  {
    id: 6,
    title: 'Покраска коммерческого объекта',
    category: 'Покраска и покрытия',
    location: 'Во',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20space%20painting%20project%20in%20Vaud%20Switzerland%2C%20large%20interior%20walls%20being%20professionally%20painted%2C%20modern%20business%20environment%2C%20quality%20paint%20application%2C%20clean%20professional%20workspace%2C%20Swiss%20construction%20standards&width=600&height=400&seq=portfolio-commercial1&orientation=landscape',
    description: 'Покраска ресторана с использованием премиальных материалов'
  },

  // Floor Coverings
  {
    id: 7,
    title: 'Укладка паркета',
    category: 'Напольные покрытия',
    location: 'Женева',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20parquet%20flooring%20installation%20in%20Geneva%20home%2C%20professional%20craftsman%20laying%20high%20quality%20wooden%20floor%2C%20elegant%20herringbone%20pattern%2C%20natural%20wood%20tones%2C%20precision%20work%20and%20perfect%20alignment%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-parquet1&orientation=landscape',
    description: 'Установка премиального паркета'
  },
  {
    id: 8,
    title: 'Керамическая плитка',
    category: 'Напольные покрытия',
    location: 'Лозанна',
    image: 'https://readdy.ai/api/search-image?query=Professional%20ceramic%20tile%20installation%20in%20Swiss%20bathroom%2C%20modern%20large%20format%20tiles%20being%20laid%2C%20precise%20alignment%20and%20spacing%2C%20quality%20materials%20and%20craftsmanship%2C%20clean%20contemporary%20design%2C%20natural%20lighting%20showing%20perfect%20finish&width=600&height=400&seq=portfolio-tiles1&orientation=landscape',
    description: 'Укладка плитки в ванной и кухне'
  },
  {
    id: 9,
    title: 'Ламинат в офисе',
    category: 'Напольные покрытия',
    location: 'Во',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laminate%20flooring%20installation%20in%20Swiss%20office%20space%2C%20professional%20workers%20laying%20quality%20laminate%2C%20contemporary%20wood-look%20finish%2C%20clean%20business%20environment%2C%20precise%20installation%20technique%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-laminate1&orientation=landscape',
    description: 'Установка ламината в офисном помещении'
  },

  // Facades and Exterior Insulation
  {
    id: 10,
    title: 'Утепление фасада дома',
    category: 'Фасады и утепление',
    location: 'Во',
    image: 'https://readdy.ai/api/search-image?query=Professional%20facade%20insulation%20work%20on%20Swiss%20house%20exterior%2C%20workers%20installing%20thermal%20insulation%20panels%20on%20building%20facade%2C%20modern%20construction%20materials%2C%20Alpine%20landscape%20background%2C%20quality%20exterior%20renovation%20work&width=600&height=400&seq=portfolio-insulation1&orientation=landscape',
    description: 'Полное утепление и облицовка частного дома'
  },
  {
    id: 11,
    title: 'Реновация фасада здания',
    category: 'Фасады и утепление',
    location: 'Женева',
    image: 'https://readdy.ai/api/search-image?query=Building%20facade%20renovation%20in%20Geneva%20Switzerland%2C%20workers%20on%20scaffolding%20restoring%20exterior%20walls%2C%20modern%20facade%20materials%20and%20finishes%20professional%20construction%20work%20urban%20Swiss%20architecture%20quality%20craftsmanship&width=600&height=400&seq=portfolio-facade1&orientation=landscape',
    description: 'Реставрация и покраска фасада многоквартирного дома'
  },
  {
    id: 12,
    title: 'Штукатурка фасада',
    category: 'Фасады и утепление',
    location: 'Монтрё',
    image: 'https://readdy.ai/api/search-image?query=Exterior%20facade%20plastering%20work%20on%20Swiss%20villa%2C%20professional%20rendering%20application%20on%20building%20exterior%2C%20smooth%20quality%20finish%20modern%20construction%20techniques%20Lake%20Geneva%20region%20landscape%20high-end%20craftsmanship&width=600&height=400&seq=portfolio-render1&orientation=landscape',
    description: 'Нанесение декоративной штукатурки на фасад виллы'
  },

  // Other Specific Projects
  {
    id: 13,
    title: 'Полная реновация квартиры',
    category: 'Специальные проекты',
    location: 'Женева',
    image: 'https://readdy.ai/api/search-image?query=Complete%20apartment%20renovation%20transformation%20in%20Geneva%2C%20before%20and%20after%20modern%20interior%20redesign%2C%20comprehensive%20construction%20work%20quality%20finishes%20throughout%20contemporary%20Swiss%20living%20space%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-renovation1&orientation=landscape',
    description: 'Полная реновация с перепланировкой и новым дизайном'
  },
  {
    id: 14,
    title: 'Трансформация ресторана',
    category: 'Специальные проекты',
    location: 'Лозанна',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20transformation%20project%20in%20Lausanne%20Switzerland%2C%20modern%20dining%20space%20renovation%20with%20new%20flooring%20walls%20and%20finishes%20professional%20commercial%20construction%20elegant%20hospitality%20design%20quality%20craftsmanship%20throughout&width=600&height=400&seq=portfolio-restaurant1&orientation=landscape',
    description: 'Полная реконструкция ресторана с новой концепцией'
  },
  {
    id: 15,
    title: 'Реновация исторического здания',
    category: 'Специальные проекты',
    location: 'Во',
    image: 'https://readdy.ai/api/search-image?query=Historic%20building%20renovation%20in%20Vaud%20Switzerland%2C%20careful%20restoration%20work%20preserving%20original%20character%20quality%20craftsmanship%20on%20traditional%20architecture%20modern%20standards%20applied%20to%20heritage%20property%20Swiss%20Alps%20background&width=600&height=400&seq=portfolio-historic1&orientation=landscape',
    description: 'Бережная реставрация с сохранением исторического характера'
  }
];

export const contact = {
  phone: '+41 77 218 45 02',
  email: 'domdavida86@gmail.com',
  address: 'Швейцария, кантоны Во и Женева',
  whatsapp: '+41772184502',
  workingHours: 'Пн-Пт: 7:00-17:00'
};
